export default class NativeSuggestions {
    constructor() {
        this.url = '/api/hints/products';
        this.abortController = null;
        this.hints = {
            phrase: { suggestions: [], meta: null },
            category: { suggestions: [], meta: null },
            product: { suggestions: [], meta: null },
        };
    }
    async getSuggestions(phrase) {
        if (this.abortController !== null) {
            this.abortController.abort();
        }
        this.abortController = new AbortController();
        return fetch(`${this.url}?search_phrase=${phrase}`, {
            method: 'GET',
            cache: 'no-cache',
            signal: this.abortController.signal,
        })
            .then((response) => {
            if (!response.ok) {
                throw new Error('Invalid response');
            }
            return response.json();
        })
            .then((json) => {
            if (typeof json.suggestions !== 'undefined') {
                this.hints.phrase.suggestions = [];
                this.hints.product.suggestions = [];
                json.suggestions.forEach((suggestion) => {
                    if (suggestion.data.navigation.type === 'product') {
                        this.hints.product.suggestions.push(suggestion);
                    }
                    else if (suggestion.data.navigation.type === 'product_list') {
                        this.hints.phrase.suggestions.push(suggestion);
                    }
                });
                if (this.hints.phrase.suggestions.length > 0 || this.hints.product.suggestions.length > 0) {
                    return this.hints;
                }
            }
            return null;
        });
    }
}
